import React from "react";
import {useLocation} from "react-router-dom";
//Material UI Components
import {Badge, Collapse, List, ListItem, ListItemIcon, ListItemText, makeStyles} from "@material-ui/core";
import {ExpandLess, ExpandMore} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    badge: {
        right: "2.5em",
    },
    miniDrawer: {
        padding: 0,
        [theme.breakpoints.down('sm')]: {
            padding: '0.4em 0 0 1.3em',
        }
    }
}));

export default function SidebarOption(props) {
    const classes = useStyles();
    const location = useLocation();

    const {title, Icon, navigate, number, xs, tabs, memberType, handleCollapse, handleNavigate, subTabs} = props;

    const isSelected = navigate === location.pathname ||
        (navigate === '/inbox' && ['/primary', '/verified', '/anonymous'].includes(location.pathname));

    const isExpandable = () => {
        if (xs && memberType !== 'Visitor' && navigate === '/inbox') {
            if (subTabs)
                return <ExpandLess/>
            else
                return <ExpandMore/>
        }
    }

    const onClick = () => {
        if (xs && memberType === "Visitor")
            handleNavigate(navigate)
        else {
            if (xs && navigate === '/inbox')
                handleCollapse()
            else
                handleNavigate(navigate)
        }
    }

    /*==========    Old onClick (Backup)    ==========*/
    /*const onClick = () => xs && memberType === 'Visitor'
        ? handleNavigate(navigate)
        : xs && navigate === '/inbox'
            ? handleCollapse()
            : handleNavigate(navigate);*/

    return (
        <>
            <ListItem key={title} button
                      onClick={onClick}
                      selected={isSelected}
            >
                <Badge max={50}
                       color="secondary"
                       badgeContent={number}
                       classes={{anchorOriginTopRightRectangle: classes.badge}}
                >
                    <ListItemIcon dangerouslySetInnerHTML={{__html: Icon}}/>
                </Badge>
                <ListItemText primary={title}/>
                {/*=========    Shows Tab Expand icon  in Mobile View   =========*/}
                {isExpandable()}
            </ListItem>
            {
                xs && navigate === '/inbox' && (
                    <Collapse in={subTabs} timeout="auto" unmountOnExit>
                        <List component="div" className={classes.miniDrawer}>
                            {tabs?.map((tab, index) =>
                                <SidebarOption
                                    key={index}
                                    Icon={tab.icon}
                                    title={tab.label}
                                    number={tab.total}
                                    navigate={`/${tab.slug}`}
                                    handleCollapse={handleCollapse}
                                    handleNavigate={handleNavigate}
                                />)}
                        </List>
                    </Collapse>
                )
            }
        </>
    );
};
